<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Account</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="3">
          <user-settings></user-settings>
        </b-col>
        <b-col md="9">
          <payment-methods></payment-methods>
          <subscription></subscription>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import UserSettings from './UserSettings';
import PaymentMethods from './PaymentMethods';
import Subscription from './Subscription';

export default {
  components: {
    RouteBreadCrumb,
    UserSettings,
    PaymentMethods,
    Subscription
  }
};
</script>